/* Qidra storefront behaviour: live cart badges, drawer-aware cart links, sticky add-to-cart.
   Everything reads from / writes to Shopify's own cart (Dawn forms + /cart.js). */
(function () {
  'use strict';

  var fmt = new Intl.NumberFormat('en');

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = fmt.format(count);
      el.hidden = count === 0;
    });
  }

  function refreshCartCount() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () {});
  }

  // Keep the mobile bottom-nav badge in sync with Dawn's cart events.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartCount);
  }

  // Bottom-nav cart link opens the drawer (when the theme uses one) instead of navigating.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-bnav-cart]');
    if (!link) return;
    var trigger = document.getElementById('cart-icon-bubble');
    if (trigger && document.querySelector('cart-drawer')) {
      e.preventDefault();
      trigger.click();
    }
  });

  // Sticky add-to-cart on the product page (mobile only, see qidra.css).
  function initSticky() {
    var submit = document.querySelector('.product-form__submit');
    var title = document.querySelector('.product__title h1') || document.querySelector('h1.product__title');
    if (!submit || !title || document.querySelector('.q-sticky')) return;

    var img = document.querySelector('.product__media img');
    var bar = document.createElement('div');
    bar.className = 'q-sticky';
    bar.innerHTML =
      (img ? '<img class="q-sticky__img" alt="" width="46" height="46">' : '') +
      '<div class="q-sticky__text"><b></b><span></span></div>' +
      '<button type="button" class="button button--primary"></button>';
    var btn = bar.querySelector('button');
    if (img) bar.querySelector('img').src = img.currentSrc || img.src;
    bar.querySelector('b').textContent = title.textContent.trim();
    document.body.appendChild(bar);

    function sync() {
      var price = document.querySelector('.product__info-container .price-item--last, .product__info-container .price-item--regular');
      if (price) bar.querySelector('span').textContent = price.textContent.trim();
      btn.textContent = submit.textContent.replace(/\s+/g, ' ').trim();
      btn.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
    }
    sync();
    new MutationObserver(sync).observe(document.querySelector('.product') || document.body, {
      subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled']
    });

    btn.addEventListener('click', function () { submit.click(); });

    new IntersectionObserver(function (entries) {
      var r = entries[0];
      bar.classList.toggle('is-on', !r.isIntersecting && r.boundingClientRect.top < 0);
    }).observe(submit);
  }

  if (document.body.classList.contains('template-product') && document.body.classList.contains('has-sticky-atc')) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
    else initSticky();
  }
})();
